import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  buttonDiv: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    type: 'button',
    cursor: 'pointer',
    marginLeft: 4,
    padding: '2px 10px',
    ':hover': {
      backgroundColor: theme.colors.gray,
      borderRadius: 9,
    },
  },
  buttons: {
    border: 'none',
    margin: ' 10px 10px 0 10px',
  },
  blue: {
    backgroundColor: `${theme.colors.primary} !important`,
    borderColor: `${theme.colors.primary} !important`,

    ':hover': {
      backgroundColor: `${theme.colors.highlightedPrimary} !important`,
      borderColor: `${theme.colors.highlightedPrimary} !important`,
    },

    ':focus': {
      backgroundColor: `${theme.colors.primary} !important`,
      borderColor: `${theme.colors.primary} !important`,
    },
  },
});
